<script lang="ts" setup>
import type { DirectoryNode, FileNode } from '~/types/custom'
import { Iconify } from '~/types/assets'

const props = defineProps<{
  paths: FileNode[]
}>()

const generateTree = (files: FileNode[]): DirectoryNode[] => {
  const treeData: DirectoryNode[] = []

  for (const file of files) {
    const chunks = file.name.split('/')
    let currentLevel = treeData

    for (const chunk of chunks) {
      const existingPath = currentLevel.find((item) => item.name === chunk)
      if (existingPath) {
        currentLevel = existingPath.children
      } else {
        const newPath: DirectoryNode = {
          name: chunk,
          children: [],
          path: file.path
        }
        currentLevel.push(newPath)
        currentLevel = newPath.children
      }
    }
  }

  return treeData
}

const tree = computed(() => generateTree(props.paths))
</script>

<template lang="pug">
.file-system
  ul
    li(v-for='node in tree' :key='node.name')
      details(v-if="node?.children?.length > 0" open)
        summary {{ node.name }}
        template(
          v-if='node.children.length > 0'
        )
          ul
            UITreeNode(
              v-for='childNode in node.children'
              :key='childNode.name'
              :node='childNode'
            )
      div(v-else)
        Icon(:name="Iconify?.open")
        NuxtLink(:to="node?.path", :no-prefetch="true") {{ node?.name }}
</template>

<style lang="sass" scoped>
.file-system
  @apply w-full mx-auto h-[50vh] max-w-[300px] lg:max-w-full lg:min-w-[450px] bg-transparent-dark overflow-y-auto overflow-x-hidden scrollbar-secondary p-4 lg:p-12 lg:px-44 rounded-md shadow border border-secondary text-primary
  ul
    @apply list-none
    li div
      @apply flex items-center gap-2
      span.iconify
        @apply text-lg
  summary
    @apply cursor-pointer
  a:hover
    @apply text-secondary
</style>
